import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import { GET } from '../consts/Methods';
import apiRoot from '../consts/apiRoot';
import { FETCH_USER_DATA, FETCH_USER_DATA_SUCCESS, FETCH_USER_DATA_FAIL } from '../redux/UserData';

function* getUserDataFlow() {
  try {
    const endpoint = `${apiRoot}/profiles`;
    const userData = yield call(apiCall, { method: GET, endpoint, });
    yield put(FETCH_USER_DATA_SUCCESS(userData));
  } catch (error) {
    yield put(FETCH_USER_DATA_FAIL(error));
  }
}

export default function* GetUserData() {
  yield takeLatest(FETCH_USER_DATA, getUserDataFlow);
}
